import { autoinject } from 'aurelia-framework';
import { BaseApiService } from './base-api-service';
import { Models } from 'models/core';
import { AuthHttpClient } from './auth-http-client';

@autoinject
export class CustomerErpSystemService extends BaseApiService<Models.CustomerErpSystem> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Models.CustomerErpSystem);
  }

  public async updateCustomerErpSystemList(data) {
    return await this.httpClient.exec(`${Models.CustomerErpSystem.ApiUrl}/updateCustomerErpSystems`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
